/*
 * @Author: Dong
 * @Date: 2022-04-08 15:22:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-26 14:52:43
 */
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useReducer, useRef, useState } from 'react';
import { cancelTask, install, unInstall, downloadLog, reinstallApi, installOperateApi } from 'root/services/manager';
import { checkExtPackApi, getExtendApi, getUpgradInfoApi } from 'root/services/packageManage';
import { operationSuposApi } from 'root/services/monitor';

import systemLogo from 'root/assets/images/logo_supos.svg';
import PopoverDelete from './TaskItem/PopoverDelete';
import TaskItem from './TaskItem';
import { TaskItemType } from './TaskItem/types';
import { useIntl } from 'react-intl';
import styles from './index.less';
import classnames from 'classnames';
import messages from './messages';
import { Progress, Button, Spin, Checkbox, Tooltip } from 'sup-ui';
import { doingIcons, doingStatus, doneStatus, successStatus, typeObj } from './TaskItem/status';
import Icon from '../Icon';
import useSuccessStatus from './TaskItem/useSuccessStatus';
import Modal from '../CommonModal';
import { initStatus, statusReducer } from './statusReducer';
import { installData } from 'root/components/FileConfig/utils';
import SelectPackage from '../SelectPackage';
import { PackageDataType, SelectedVersionType } from '../FileConfig/types';
import LogsDetail from './LogsDetail';
import { useAsyncState } from 'root/common/useAsyncState';
import { useDispatch } from 'react-redux';
import { common, installList } from 'root/store/actions';

import { message } from 'sup-ui';
import { downloadFiles } from 'root/utils/utils';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
interface PropsType {
  className?: string;
  updateQueueChange?: (queues: PackageDataType[]) => void;
  noSuposCallback?: (visible: boolean) => void;
  canceledSupos?: () => void;
  showSupOS?: boolean;
  showExtendedService?: boolean;
  catalog?: string;
}

const { confirm } = Modal;

const strokeColors: { [x: string]: any } = {
  upgrade: '#2280fa',
  uninstall: '#646e79',
};

// eslint-disable-next-line complexity
const InstallList = (props: PropsType, ref: React.Ref<unknown> | undefined) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const isSupos = window.location.hash === '#/supos';
  const loopTimer = useRef<any>(null);

  const {
    className,
    canceledSupos,
    updateQueueChange,
    noSuposCallback,
    showSupOS,
    showExtendedService,
    catalog = '',
  } = props;

  const [systemInfo, setSystemInfo] = useAsyncState<any>({}); // 操作系统信息
  const [dataSource, setDataSource] = useAsyncState<TaskItemType[]>([]); // 列表数据
  const successType = useSuccessStatus(systemInfo); // 系统升级成功提示显隐状态
  const [status, statusDispatch] = useReducer(statusReducer, initStatus);
  const [suposStatus, setSuposStatus] = useAsyncState<string>(''); // supOS的状态
  const [hasFailedTask, setHasFailedTask] = useAsyncState<boolean>(false); // 是否存在失败的任务
  const [visibleDetail, setVisibleDetail] = useState(false); // 详情显隐状态
  const [installSupos, setInstallSupos] = useState(false); // 是否安装了supos
  const fileConfigRef = useRef<any>(null);
  const [loadingObj, setloadingObj] = useState({ name: '', loading: false }); // 加载中对象
  const [modalCatalog, setModalCatalog] = useState('extension');
  const [selectSpinning, setSelectSpinning] = useState(false); // 选择安装包弹框的loading

  const { cluster, acitveKey } = useSelector((state: reducerStates) => state.envManage);
  const { updateMethodList } = useSelector((state: reducerStates) => state.fileConfig);

  const [taskVisbleObj, setTaskVisbleObj] = useState<any>({});
  const [clusterTaskData, setClusterTaskData] = useState<any>({});
  const initFlag = useRef<any>(false);
  const [middlewareInfo, setMiddlewareInfo] = useState<any>({});
  const [agreementCheck, setAgreementCheck] = useState(false); // 升级二次确认选择协议
  const [upgradConfirmInfo, setUpgradConfirmInfo] = useState<any>({}); // 升级
  const [upgradInfo, setUpgradInfo] = useState<any>({}); // 无扰升级提示信息
  const [showDecompressionTip, setShowDecompressionTip] = useState(false); // 显示解压中提示

  // 暴露给父组件的实例值
  useImperativeHandle(ref, () => ({
    clickBtn: clickBtn, // 用于父组件触发弹框显示
  }));

  // 获取安装列表
  useEffect(() => {
    // 只有安装页面和系统管理的第一个选项卡去获取
    const hash = location.hash;
    if ((acitveKey === '1' && hash === '#/instances') || hash === '#/supos') {
      getList();
      return;
    }

    clearTimeout(loopTimer.current);
    loopTimer.current = null;
  }, [acitveKey]);

  useEffect(() => {
    return () => {
      clearTimeout(loopTimer.current);
      loopTimer.current = null;
    };
  }, []);

  // 清空上传队列数据
  useEffect(() => {
    if (!fileConfigRef.current?.clearData || status.visible) return;

    fileConfigRef.current.clearData();
  }, [status.visible]);

  // 是否展示supos进度条
  const showSystemProgress = useMemo(() => {
    if (!systemInfo.type) return false;

    // 只有安装,升级和卸载supos才展示进度条
    if (!['upgrade', 'uninstall', 'install', 'rollBack'].includes(systemInfo.type)) return false;

    // 进行中、失败，显示进度条
    // 成功后，继续维持1s，然后隐去进度条
    return (
      (systemInfo.status &&
        [
          'installing',
          'upgrading',
          'failure',
          'upgrading',
          'uninstalling',
          'non_disruptive_upgrading',
          'disruptive_upgrading',
          'rolling_back',
        ].includes(systemInfo.status)) ||
      successType !== ''
    );
    // return (systemInfo.status && ['doing', 'failure'].includes(systemInfo.status)) || showSuccess;
  }, [systemInfo, successType]);

  // 是否显示系统卸载按钮
  const showSystemUninstall = useMemo(() => {
    // 向导安装界面，不显示卸载按钮
    if (isSupos) return false;
    // 安装、升级，显示按钮
    if (systemInfo.type !== 'uninstall') return true;

    // 卸载失败，显示按钮
    if (systemInfo.status === 'failure') return true;

    return false;
  }, [systemInfo]);

  // 已安装组件数据 extension：扩展服务   system：系统服务   空为所有
  const getList = () => {
    const params = {
      catalog,
      requestType: '',
      archiveId: '',
    };
    getExtendApi(params).then((res: any) => {
      let { data = [] } = res;

      // 当列表数据未空，显示未安装界面  更新store状态，禁用系统监控和备份还原菜单
      if (!data.length) {
        dispatch(
          common.serverStatus({
            noSupos: true,
          }),
        );
      }
      // 更新扩展服务列表显示
      if (noSuposCallback) {
        const visible = data.length ? false : true;
        noSuposCallback(visible);
      }

      // 判断失败状态
      data = data.map((item: any) => {
        item.status = item.status.toLowerCase();

        if (item.err) {
          item.status = 'failure';
        }
        if (item.name === 'supos') {
          setSuposStatus(item.status);
        }
        item.type = typeObj[item.type];
        // 回滚中的type也是2,需要继续判断updateMethod
        if (item.updateMethod === 3) {
          item.type = typeObj[7];
        }
        return item;
      });

      if (updateQueueChange) {
        updateQueueChange(data);
      }

      // 有等待或者正在进行中的任务，轮询查数据  UPGRADING WAITING(兼容手动操作,所有状态都轮询)
      // const isLoop =
      //   data?.length &&
      //   data.find((item: any) =>
      //     ['installing', 'upgrading', 'uninstalling', 'waiting', 'stopping', 'pending'].includes(item.status),
      //   );

      // 提取系统信息
      const index = data.findIndex((item: { name: string }) => item.name === 'supos');

      if (index !== -1) {
        const system = data.splice(index, 1)[0];
        setSystemInfo({ ...system });
        if (['running', 'run_with_high_risk', 'run_with_low_risk'].includes(system.status)) setInstallSupos(true);
      }

      setDataSource([...data]);

      // 集群环境
      if (cluster) {
        // 数据分类
        const newData: any = {};
        const tempVisble: any = {};

        data.forEach((item: any) => {
          const { catalog } = item;

          if (!newData[catalog]) {
            newData[catalog] = [item];
            tempVisble[catalog] = true;
            return;
          }
          newData[catalog].push(item);
        });

        // 设置显隐的对象只有第一次渲染的时候更新
        if (!initFlag.current) {
          initFlag.current = true;
          setTaskVisbleObj(tempVisble);
        }
        setClusterTaskData(newData);

        // 设置中间件信息
        const { middleware } = newData;
        if (middleware) {
          const count = middleware.filter((item: any) => item.status === 'running').length;
          setMiddlewareInfo({
            running: count,
            total: middleware.length,
          });
        } else {
          setMiddlewareInfo({
            running: 0,
            total: 0,
          });
        }
      }
      // 判断是否有失败的任务
      setHasFailedTask(!!data.find((item: any) => item.err));

      clearTimeout(loopTimer.current);
      loopTimer.current = setTimeout(() => {
        getList();
      }, 10 * 1000);
    });
  };

  // 卸载确认
  const handleUninstall = (name: string) => {
    // 卸载supos，需要卸载所有组件
    unInstall({ name }).then(() => {
      getList();
    });
  };

  // 停止/启动 扩展服务 type  1:启动  2 停止
  const operateStatus = (name: string, type: string, callback: (name: string, loading: boolean) => void) => {
    operationSuposApi({ name, type })
      .then(() => {
        getList();
      })
      .finally(() => {
        callback(name, false);
      });
  };

  // 回滚
  const rollBack = (data: any) => {
    const { archiveId, name } = data;
    const params = {
      // updateMethod:0无扰升级  1有扰升级  2 离线安装   3回滚
      modules: [
        {
          name,
          archiveId,
          type: 2,
          updateMethod: 3,
        },
      ],
      hosts: {},
    };
    changeLoading('supos', true);
    install(params)
      .then(() => {
        getList();
      })
      .finally(() => {
        changeLoading('supos', false);
      });
  };

  const toggleVisibleDetail = () => {
    setVisibleDetail(!visibleDetail);
  };
  const statusRender: { [x: string]: React.ReactNode } | null = useMemo(() => {
    let mode = '';
    if (systemInfo.updateMethod === 0) mode = intl.formatMessage(messages.undisturbed);
    if (systemInfo.updateMethod === 1) mode = intl.formatMessage(messages.disturbance);
    const undisturbedMode = systemInfo.updateMethod === 0 || systemInfo.updateMethod === 1;

    return {
      // 等待中
      waiting: middlewareInfo.total ? (
        <span>
          {intl.formatMessage(messages.waitingMiddleware)}
          {` ${middlewareInfo.running}/${middlewareInfo.total}`}
        </span>
      ) : (
        <span>{intl.formatMessage(messages.waiting)}...</span>
      ),
      // 进行中，显示具体进度值
      doing: (
        <>
          {doingIcons[systemInfo.type] && <Icon type={doingIcons[systemInfo.type]} />}
          {doingStatus[systemInfo.type] && !undisturbedMode && (
            <span>{intl.formatMessage(doingStatus[systemInfo.type])}...</span>
          )}
          {undisturbedMode ? <span>{mode}...</span> : null}
          <span>{systemInfo.percent}%</span>
        </>
      ),
      // 成功后，显示成功，1s后隐藏状态
      success: (
        <>
          {doneStatus[isSupos ? 'install' : successType] && (
            <Icon type={doneStatus[isSupos ? 'install' : successType]} />
          )}
          {successStatus[isSupos ? 'install' : successType] && (
            <span>{intl.formatMessage(successStatus[isSupos ? 'install' : successType])}</span>
          )}
        </>
      ),
      // 失败
      failure: (
        <div>
          {systemInfo.updateMethod === 3 && (
            <Button size="small" onClick={() => handleCancelTask('supos', systemInfo.type)} style={{ marginLeft: 8 }}>
              {intl.formatMessage(messages.cancel)}
            </Button>
          )}
          {['install', 'upgrade'].includes(systemInfo.type) && (
            <div className={styles.btns}>
              {systemInfo.updateMethod === 0 || systemInfo.updateMethod === 1 ? (
                <>
                  <Button
                    size="small"
                    onClick={() => {
                      installOperate();
                    }}
                    style={{ marginRight: '10px' }}
                  >
                    {intl.formatMessage(messages.continueInstall)}
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      rollBack(systemInfo);
                    }}
                    style={{ marginRight: '10px' }}
                  >
                    {intl.formatMessage(messages.rollBack)}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    size="small"
                    onClick={() => reInstall('supos')}
                    title={intl.formatMessage(messages[`${systemInfo.type}BtnTip`])}
                  >
                    {systemInfo.type &&
                      `${intl.formatMessage(messages.reInstall)}${intl.formatMessage(messages[systemInfo.type])}`}
                  </Button>
                  <Button
                    size="small"
                    onClick={() => handleCancelTask('supos', systemInfo.type)}
                    style={{ marginLeft: 8 }}
                    title={intl.formatMessage(messages[`cancel${systemInfo.type}Tip`])}
                  >
                    {intl.formatMessage(messages.cancel)}
                  </Button>
                </>
              )}
            </div>
          )}
        </div>
      ),
    };
  }, [systemInfo, successType, dataSource, middlewareInfo, clusterTaskData]);

  // 渲染系统进度
  const renderSystemStatus = useMemo(() => {
    const status = systemInfo.err // 失败
      ? 'failure'
      : !systemInfo.percent && (successType !== '' || isSupos) && systemInfo.type && systemInfo.status !== 'waiting' // 成功，向导安装界面，一直显示成功状态
      ? 'success'
      : [
          'installing',
          'upgrading',
          'uninstalling',
          'non_disruptive_upgrading',
          'disruptive_upgrading',
          'rolling_back',
        ].includes(systemInfo.status) // 进行中
      ? 'doing'
      : systemInfo.status;

    return (status && statusRender?.[status] && <div className={styles.status}>{statusRender[status]}</div>) || null;
  }, [systemInfo, successType, dataSource, middlewareInfo, clusterTaskData]);

  // 显示组件列表选择Modal
  const clickBtn = (type: string, catalog?: string) => {
    setModalCatalog(catalog || 'extension');
    statusDispatch({ type: 'clickBtn', params: { type: type || '' } });
  };

  const handleCancel = () => {
    statusDispatch({ type: 'toggleVisible' });
    setSelectSpinning(false);

    // 防止状态重置后,Modal按钮文字闪现
    setTimeout(() => {
      statusDispatch({ type: 'clearType' });
    }, 0);
  };

  // 取消任务
  const handleCancelTask = (name: string, type: string) => {
    const typeI18n = intl.formatMessage(messages[type]);

    confirm({
      title: intl.formatMessage(name === 'supos' ? messages.systemCancelTip : messages.cancelTip, { type: typeI18n }),
      onOk: () => {
        cancelTask({ name: name === 'supos' ? 'ALL' : name }).then(() => {
          // 不存在安装列表，或者取消supos，则显示已取消supos安装
          if ((name === 'supos' || dataSource.length === 1) && canceledSupos) {
            return canceledSupos();
          }

          // 系统管理页面的supos需要更新页面
          if (catalog === 'system') {
            dispatch(installList.setOperate('cancelIntall'));
            return;
          }
          getList();
        });
      },
    });
  };

  // 确认安装、升级
  const handleOk = async () => {
    // 获取安装数据
    const data = fileConfigRef.current?.getReadyInstallData();

    const updateMethodObj: any = {};
    const packageConfObj: any = {};
    updateMethodList.forEach((ele) => {
      const { name, updateMethod, archiveId, affectBusiness, packageConf } = ele;
      if (archiveId === data[name]) {
        updateMethodObj[name] = updateMethod;
        packageConfObj[name] = packageConf;
      }
      if (name === 'supos') {
        systemInfo.updateMethod = updateMethod;
        systemInfo.affectBusiness = affectBusiness;
      }
    });

    let params = installData(data, status.type, null, updateMethodObj);
    let isCheckPass = true;

    // 校验表单
    if (window.moduleForms) {
      Object.keys(window?.moduleForms)?.forEach((name: any) => {
        // 只校验选中组件的表单

        if (!params?.find((item) => item.archiveId === name)) return;

        window.moduleForms[name].validateFields((err: any, values: any) => {
          if (err) {
            isCheckPass = false;
            return;
          }
          // 把对应的表单信息添加到params中
          params = params?.map((i) => {
            if (i.archiveId === name) {
              return { ...i, form: { ...values } };
            }
            return i;
          });
        });
      });
    }

    // 校验不通过，不进行安装
    if (!isCheckPass) return;
    setSelectSpinning(true);

    const checkDepend = await checkDependencies(params);

    if (!checkDepend) {
      setSelectSpinning(false);
      return;
    }
    // 系统升级需要弹出确认框
    if (modalCatalog === 'system' && status.type === 'upgrade') {
      // 集群环境 无扰升级和有有扰升级单独的弹框
      if (cluster && (updateMethodObj.supos === 0 || updateMethodObj.supos === 1)) {
        setSelectSpinning(true);
        setShowDecompressionTip(true);
        await getUpgradInfoApi([{ archiveId: data.supos, moduleName: 'supos', packageConf: packageConfObj.supos }])
          .then((res) => {
            setUpgradInfo(res?.data[0]);
            systemInfo.updateMethod = res?.data[0].updateMethod;
            setUpgradConfirmInfo({
              visable: true,
              data: params,
              upgradeConfim: res.data,
            });
          })
          .finally(() => {
            setSelectSpinning(false);
            setShowDecompressionTip(false);
          });

        return;
      }

      setSelectSpinning(false);
      confirm({
        title: intl.formatMessage(messages.upgradeTitle),
        width: '500px',
        content: (
          <div className={styles.upgradConfirm}>
            {intl.formatMessage(cluster ? messages.clusteredUpgradeContent : messages.upgradeContent)}
          </div>
        ),
        onOk: () => {
          setSelectSpinning(true);
          installPost(params);
        },
        onCancel: () => {
          setSelectSpinning(false);
        },
      });
      return;
    }

    if (modalCatalog === 'extension' && status.type === 'upgrade') {
      // 集群环境 无扰升级和有有扰升级单独的弹框
      const upgradeList = params?.filter((item) => item.updateMethod === 0 || item.updateMethod === 1);
      const upgradeParams = upgradeList?.map((item) => {
        const { name, archiveId } = item;
        return { archiveId, moduleName: name, packageConf: packageConfObj[name] };
      });

      if (cluster && upgradeList?.length) {
        setSelectSpinning(true);
        setShowDecompressionTip(true);
        await getUpgradInfoApi(upgradeParams)
          .then((res) => {
            setUpgradConfirmInfo({
              visable: true,
              data: params,
              upgradeConfim: res.data, // 扩展服务需要展示的提示信息
            });
          })
          .finally(() => {
            setSelectSpinning(false);
            setShowDecompressionTip(false);
          });
        return;
      }
    }
    installPost(params);
  };
  // supos无扰/有扰升级确认信息
  const upgradeContext = () => {
    return (
      <div className={styles.updateInfo}>
        <div>
          <span
            className={styles.updateMethod}
            style={systemInfo.updateMethod === 1 ? { background: '#f8cecc', borderColor: '#b85450' } : {}}
          >
            {intl.formatMessage(systemInfo.updateMethod === 1 ? messages.disturbance : messages.undisturbed)}
          </span>
          <span className={styles.version}>supOS{upgradInfo.updateDesc}</span>
        </div>
        {/* <div className={styles.confirmText}>{systemInfo.affectBusiness}</div> */}
        <div className={styles.updatetip}>
          <h3 className={styles.updateTitle}>注意事项:</h3>
          {systemInfo.updateMethod === 0 ? (
            <div>
              <p>1.服务更新的过程中业务可以正常使用</p>
              <p>2.正在更新的服务在切换时有可能有短暂几次失败，重试可以恢复</p>
              <p>3.请保持关注升级页面，如果出现升级失败，平台会自动重试3次，如果依旧失败可以选择:</p>
            </div>
          ) : (
            <div>
              <p>1.进行有扰升级的服务在升级过程业务不可以使用，请提前沟通好升级时间</p>
              <p>2.请保持关注升级页面，如果出现升级失败，平台会自动重试3次，如果依旧失败可以选择</p>
            </div>
          )}

          <p className={styles.tipItem}>1)联系技术支持进行处理，确认处理后，然后选择[恢复安装]继续安装</p>
          <p className={styles.tipItem}>2)选择[回滚版本]进行回滚，如果回滚过程中出现失败，请直接联系技术支持进行处理</p>
        </div>

        {upgradInfo?.mustDisturbService?.length ? (
          <>
            <div className={styles.updateTitle}>必须有扰升级的服务</div>
            {upgradInfo?.mustDisturbService?.map((item: string) => {
              return <div key={item}>{item}</div>;
            })}
          </>
        ) : null}

        <div className={styles.updateTitle}>服务升级顺序</div>
        {upgradInfo?.updateOrder?.map((item: string) => {
          return <div key={item}>{item}</div>;
        })}
      </div>
    );
  };

  // 扩展服务无扰/有扰升级确认信息
  const extentUpgradeContext = () => {
    let str = '';
    upgradConfirmInfo?.upgradeConfim?.forEach((item: any) => {
      str += `${item.title}：${intl.formatMessage(
        item.updateMethod === 1 ? messages.disturbance : messages.undisturbed,
      )} <br />`;
    });

    return <span dangerouslySetInnerHTML={{ __html: str }} />;
  };

  const agreementChange = (val: any) => {
    const check = val.target.checked;
    setAgreementCheck(check);
  };

  // 升级
  const installPost = (params: any) => {
    params.forEach((item: any) => {
      // supos的升级方式动用接口动态值
      params.forEach((item: any) => {
        const data = upgradConfirmInfo?.upgradeConfim?.find((i: any) => {
          return i.name === item.name;
        });
        item.updateMethod = data ? data.updateMethod : item.updateMethod;
      });
      // 单机环境不支持无扰升级,修改安装包升级方式为离线安装
      if (item.type === 1 || (!cluster && (item.updateMethod === 0 || item.updateMethod === 1))) {
        item.updateMethod = 2;
      }
    });

    install({ modules: params })
      .then(() => {
        statusDispatch({ type: 'toggleVisible' });
        setUpgradConfirmInfo({});
        // 如果是supos升级,点击升级后跟新supos状态
        dispatch(installList.setOperate('upgradeSupos'));

        getList();
      })
      .finally(() => {
        setSelectSpinning(false);
      });
  };

  // 检查安装包依赖关系
  const checkDependencies = async (params: any) => {
    let result = false;

    // 如果是首次安装 需要添加supos数据
    if (!catalog) params.push({ name: 'supos', archiveId: systemInfo.archiveId });

    await checkExtPackApi(params).then((res) => {
      const { data } = res;
      if (!data || !data.length) {
        result = true;
        return;
      }

      let str = '';
      data.forEach((item: any) => {
        const { name, dependName, errorType } = item;
        if (errorType === 1) {
          str = `${str}${intl.formatMessage(messages.dependNullTip, { name, dependName })};`;
        }
        if (errorType === 2) {
          str = `${str}${intl.formatMessage(messages.dependVerisonTip, { name, dependName })};`;
        }
      });
      message.error(str);
    });

    return result;
  };

  // 重新安装
  const reInstall = async (moduleName: string, callback?: () => void) => {
    reinstallApi({ moduleName }).then(() => {
      getList();
      if (callback) callback();
    });
  };

  // 继续安装(恢复)
  const installOperate = () => {
    changeLoading('supos', true);
    installOperateApi(2)
      .then(() => {
        getList();
      })
      .finally(() => {
        changeLoading('supos', false);
      });
  };

  // 根据选择内容判断按钮状态
  const uploadQueueChange = (selectedVersion: SelectedVersionType) => {
    const isFinish = Object.keys(selectedVersion).length;

    if (isFinish) {
      return statusDispatch({ type: 'btnActive', params: { disabled: false } });
    }
    return statusDispatch({ type: 'btnActive', params: { disabled: true } });
  };

  // 改变loading状态
  const changeLoading = (name: string, loading: boolean) => {
    setloadingObj({ name, loading });
  };

  const classname = classnames(styles.system, {
    [styles.installing]: showSystemProgress && systemInfo.type === 'install' && systemInfo.percent,
    [styles.upgrading]: showSystemProgress && systemInfo.type === 'upgrade' && systemInfo.percent,
    [styles.uninstalling]: showSystemProgress && systemInfo.type === 'uninstall' && systemInfo.percent,
    [styles.systemManage]: catalog === 'system',
    [styles.fail]: catalog === 'system' && systemInfo.err,
    [styles.waiting]: catalog === 'system' && systemInfo.status === 'waiting',
  });

  const detailClassname = classnames(styles.detail, {
    [styles.showDetailList]: visibleDetail,
    [styles.detailSys]: visibleDetail && catalog === 'system',
  });

  // 下载日志
  const downloadLogList = (name: string) => {
    downloadLog(name).then((res) => {
      const { data, headers } = res;
      const fileName = headers['content-disposition']?.split('filename=')[1];
      if (!fileName) return message.error(intl.formatMessage(messages.logNull));

      downloadFiles(data, fileName);
    });
  };

  // 渲染suposOS结构（首次安装需要展示）
  // eslint-disable-next-line complexity
  const supOSContent = () => {
    return (
      <div style={{ marginBottom: showSystemProgress && !systemInfo.err ? 25 : 0 }}>
        <Spin spinning={loadingObj.loading}>
          <div className={classname}>
            <img className={styles.logo} src={systemLogo} alt="" />
            <h2 className={styles.title}>{intl.formatMessage(messages.systemTitle)}</h2>
            <span className={styles.version}>
              {intl.formatMessage(messages.version)} {systemInfo.version}
            </span>
            {renderSystemStatus}
            {showSystemUninstall && (
              <PopoverDelete
                className={styles.popover}
                deleteTip={intl.formatMessage(messages.systemUninstallTip)}
                deleteCallback={() => handleUninstall('supos')}
                name="supos"
                changeLoading={changeLoading}
              />
            )}
            {showSystemProgress && (
              <div>
                <Progress
                  className={styles.progress}
                  percent={systemInfo?.status === 'failure' ? 100 : Number(systemInfo.percent)}
                  showInfo={false}
                  strokeWidth={4}
                  strokeColor={
                    systemInfo?.status === 'failure' ? '#d20c0c' : systemInfo.type && strokeColors[systemInfo.type]
                  }
                />
                {/* 展示摘要信息 */}
                {!systemInfo.err ? (
                  // (systemInfo.updateMethod === 0 || systemInfo.updateMethod === 1 || systemInfo.updateMethod === 3) ?
                  <Tooltip title={systemInfo.describe}>
                    <div className={styles.abstract}>{systemInfo.describe}</div>
                  </Tooltip>
                ) : null}
              </div>
            )}
          </div>

          {systemInfo.err && (
            <div className={styles.failPanel}>
              <div>
                <Progress
                  className={styles.progress}
                  percent={systemInfo?.status === 'failure' ? 100 : Number(systemInfo.percent)}
                  showInfo={false}
                  strokeWidth={4}
                  strokeColor={
                    systemInfo?.status === 'failure' ? '#d20c0c' : systemInfo.type && strokeColors[systemInfo.type]
                  }
                />
                <div className={styles.failInfo}>
                  {systemInfo.type && (
                    <p className={styles.failTxt}>
                      {systemInfo.updateMethod === 0 && <span>{intl.formatMessage(messages.undisturbedText)}</span>}
                      {systemInfo.updateMethod === 1 && <span>{intl.formatMessage(messages.disturbanceText)}</span>}
                      {`${intl.formatMessage(messages[systemInfo.type])}${intl.formatMessage(messages.failed)}`}
                    </p>
                  )}
                  <span
                    className={visibleDetail ? ` ${styles.place}  ${styles.downloadLog}  ` : styles.downloadLog}
                    onClick={() => {
                      downloadLogList('supos');
                    }}
                  >
                    {intl.formatMessage(messages.downloadLog)}
                  </span>
                  <span className={detailClassname} onClick={toggleVisibleDetail}>
                    {intl.formatMessage(messages.detail)}

                    <Icon type={visibleDetail ? 'bluearrow16_up' : 'bluearrow16_down'} />
                  </span>
                </div>
              </div>
              <div />
              {visibleDetail && <LogsDetail logs={systemInfo.logs} err={systemInfo.err} catalog={catalog} />}
            </div>
          )}

          {/* PENDING 启动中  RESTARTING 重启中  STOPPING 停止中  STOPPED 已停止  UPDATING 更新配置中  */}
          {['PENDING', 'RESTARTING', 'STOPPING', 'STOPPED', 'UPDATING'].includes(suposStatus) && hasFailedTask && (
            <p className={styles.tip}>{intl.formatMessage(messages.suposRunningTip)}</p>
          )}
        </Spin>
      </div>
    );
  };

  const renderTask = () => {
    // 集群环境并且首次安装界面
    if (cluster && !catalog) {
      return Object.keys(clusterTaskData).map((item) => {
        return (
          <div key={item}>
            <h3 className={styles.taskTitle}>
              <span>{item !== 'null' && intl.formatMessage(messages[item])}</span>
              <Icon
                type={taskVisbleObj[item] ? 'bluearrow16_down' : 'bluearrow16_up'}
                className={styles.arrow}
                onClick={() => {
                  setTaskVisbleObj({ ...taskVisbleObj, [item]: !taskVisbleObj[item] });
                }}
              />
            </h3>
            <div style={taskVisbleObj[item] ? {} : { height: 0, overflow: 'hidden' }}>
              {renderTaskItem(clusterTaskData[item])}
            </div>
          </div>
        );
      });
    }
    // 单机环境
    return renderTaskItem(dataSource);
  };

  const renderTaskItem = (dataSource: any) => {
    if (!dataSource.length) return;
    return dataSource.map((item: any) => {
      return (
        <TaskItem
          key={item.name}
          {...item}
          popoverDelete={handleUninstall}
          reInstall={reInstall}
          cancelTask={handleCancelTask}
          installSupos={installSupos}
          changeLoading={changeLoading}
          operateStatus={operateStatus}
          downloadLogList={downloadLogList}
          rollBack={rollBack}
        />
      );
    });
  };
  return (
    <div className={styles.container}>
      {showSupOS && supOSContent()}
      {showExtendedService && <div className={classnames({ className: !!className })}>{renderTask()}</div>}

      <Modal
        destroyOnClose
        visible={status.visible}
        title={intl.formatMessage(messages.installModalTitle)}
        width={800}
        bodyStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        okText={intl.formatMessage(messages[`${status.type === 'upgrade' ? 'upgrade' : 'install'}`])}
        okButtonProps={{
          disabled: status.disabled || selectSpinning,
        }}
        onOk={handleOk}
        onCancel={handleCancel}
        btnAlgin="left"
      >
        <Spin
          wrapperClassName={styles.selectSpin}
          tip={showDecompressionTip ? intl.formatMessage(messages.decompressionPrompt) : ''}
          spinning={selectSpinning}
        >
          <SelectPackage
            ref={fileConfigRef}
            uploadQueueChange={uploadQueueChange}
            type={status.type}
            catalog={modalCatalog}
          />
        </Spin>
      </Modal>

      <Modal
        title={intl.formatMessage(messages.upgradeTitle)}
        // className={styles.upgradConfirm}
        visible={upgradConfirmInfo.visable}
        height="auto"
        onOk={() => {
          installPost(upgradConfirmInfo.data);
          setSelectSpinning(true);
        }}
        onCancel={() => {
          setSelectSpinning(false);
          setUpgradConfirmInfo({});
        }}
        width="550"
        okButtonProps={{
          disabled:
            (!agreementCheck &&
              (upgradConfirmInfo?.upgradeConfim?.some((item: any) => item.updateMethod === 1) ||
                systemInfo.updateMethod === 1)) ||
            selectSpinning,
        }}
      >
        <Spin wrapperClassName={styles.selectSpin} spinning={selectSpinning}>
          {modalCatalog === 'system' ? upgradeContext() : extentUpgradeContext()}

          <div className={styles.agreement}>
            {systemInfo.updateMethod === 1 ||
            upgradConfirmInfo?.upgradeConfim?.some((item: any) => item.updateMethod === 1) ? (
              <Checkbox onChange={agreementChange}>{intl.formatMessage(messages.disturbanceUpgradeProtocol)}</Checkbox>
            ) : null}
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default forwardRef(InstallList);
